import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../AbstractElements';
import DataTablesContain from '../../Component/Tables/DataTable4';
import { useTranslation } from 'react-i18next';

const DataTable3 = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Dashboard")} title={t("Digital Id List" )} />
      <DataTablesContain />
    </Fragment>
  );
};
export default DataTable3;
